// extracted by mini-css-extract-plugin
module.exports = {"searchResultsRoot":"BXoEK04N","filtersWrapper":"c0zcDutv","filters":"MWzmHy2J","list":"GvmpukaB"};